"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHeaderMenuItemsMobile = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var media_1 = require("../../../../../styles/media");
var header_menu_items_style_1 = require("../header-menu-items-style");
exports.StyledHeaderMenuItemsMobile = (0, styled_components_1.default)(header_menu_items_style_1.StyledHeaderGroup)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: none;\n\n  ", "\n"], ["\n  display: none;\n\n  ", "\n"])), (0, media_1.mediaStyle)(media_1.MediaScreenSize.TABLET)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n  "], ["\n    display: block;\n  "]))));
var templateObject_1, templateObject_2;
